import { createContext, useContext, type ReactNode } from 'react';

// ---------------------------------------------------------------------------
// SINAIS DA PRÉVIA DO CRM (Modelos do site, 19/10/2026) — vêm do ?tema= (só host de
// teste, ver lib/server/theme-preview.ts) e chegam aqui por props.themePreview no _app.
//
//  • videoParado  (`video:parado`)   — cards da galeria: o vídeo do topo fica parado na
//    capa e não é baixado (11 sites carregando juntos). A prévia aberta não manda.
//  • filiaisFechado (`filiais:fechado`) — popup/tela de filial não abrem sozinhos (no
//    iframe toda visita é a 1ª).
//
// Fora da prévia (todo visitante real) os dois são false: o site não muda em nada.
// ---------------------------------------------------------------------------

export type PreviaBuilder = { videoParado: boolean; filiaisFechado: boolean };

const SEM_PREVIA: PreviaBuilder = { videoParado: false, filiaisFechado: false };

const PreviaBuilderContext = createContext<PreviaBuilder>(SEM_PREVIA);

export function PreviaBuilderProvider({ value, children }: { value: PreviaBuilder; children: ReactNode }) {
  return <PreviaBuilderContext.Provider value={value}>{children}</PreviaBuilderContext.Provider>;
}

export const usePreviaBuilder = (): PreviaBuilder => useContext(PreviaBuilderContext);
